export const SETTINGS_LOCATIONS_PATH = '/app/overview/settings?locations';

export const buildLocationCreatePath = () => '/app/overview/settings/locations/new';

export const buildLocationEditPath = (locationId) => (
  `/app/overview/settings/locations/${encodeURIComponent(locationId)}/edit`
);

export const locationsSettingsNavigationState = () => ({
  section: 'locations',
  parent: 'locations',
});

export const parseLocationSettingsRoute = (pathname = '') => {
  if (pathname.endsWith('/settings/locations/new')) {
    return { type: 'create' };
  }

  const match = pathname.match(/\/settings\/locations\/([^/]+)\/edit$/);
  if (match) {
    return { type: 'edit', locationId: decodeURIComponent(match[1]) };
  }

  return null;
};

export const isLocationSettingsDetailRoute = (pathname = '') => (
  parseLocationSettingsRoute(pathname) != null
);
